import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { FeatureService } from '@woolworthsnz/styleguide';
import { ApiService, AppSettingsService } from '@woolworthsnz/styleguide';
import { BoostOffersResponseV3, BoostOffersResponse, ContextResponse } from '@woolworthsnz/trader-api';
import { BoostOfferResponseV2 } from '../../features/boosts/models/boost-offer-status.enum';

@Injectable({
	providedIn: 'root',
})
export class BoostService {
	constructor(
		private apiService: ApiService,
		private appSettingsService: AppSettingsService,
		private featureService: FeatureService
	) {}

	public fetchBoostOffers(): Observable<BoostOfferResponseV2[]> {
		if (this.featureService.isFeatureEnabled(ContextResponse.EnabledFeaturesEnum.EnableBoostOffersV3)) {
			return (
				this.apiService.get(
					this.appSettingsService.getEndpoint('myOffers', 2)
				) as Observable<BoostOffersResponseV3>
			).pipe(map((result: BoostOffersResponseV3) => result.offers || []));
		} else {
			return (
				this.apiService.get(this.appSettingsService.getEndpoint('myOffers')) as Observable<BoostOffersResponse>
			).pipe(map((result: BoostOffersResponse) => result.offers || []));
		}
	}

	public fetchBoostOffer(id: string): Observable<BoostOfferResponseV2> {
		if (this.featureService.isFeatureEnabled(ContextResponse.EnabledFeaturesEnum.EnableBoostOffersV3)) {
			return this.apiService.get(`${this.appSettingsService.getEndpoint('myOffers', 2)}/${id}`);
		} else {
			return this.apiService.get(`${this.appSettingsService.getEndpoint('myOffers')}/${id}`);
		}
	}

	public activateBoostOffer(id: string): Observable<void> {
		return this.apiService.post(`${this.appSettingsService.getEndpoint('myOffers')}/boost`, { offerIds: [id] });
	}

	public activateAllBoostOffers(): Observable<void> {
		return this.apiService.post(`${this.appSettingsService.getEndpoint('myOffers')}/boost-all`, {});
	}
}
